export default {
    BRAND_PAGE: 'Brand',
    BRAND_LIST_PAGE: 'BrandList',
    CATEGORY_LIST: 'CategoryList',
    CATEGORY_RESULT_PAGE: 'Category',
    CUSTOM_RESULT_PAGE: 'CUSTOM_RESULT_PAGE',
    ENDLESS_RECOMMENDATIONS_PAGE: 'EndlessRecommendation',
    DEFAULT: 'default',
    SEARCH_RESULT_PAGE: 'SearchResults',
    START_PAGE: 'StartPage'
};
